<template>
  <div class="flex flex-wrap justify-center p-6">


     <div class="w-full md:w-1/2 lg:w-1/3 xl:w-1/5 m-1 rounded overflow-hidden shadow-lg">
      <a href="https://ktsh-ks.com">
        <img class="w-full" src="https://ktsh-ks.com/img/logo-1682851184.jpg" alt="Shop Image" />
        <div class="px-6 py-4">
          <div class="font-bold text-xl mb-2">Kosova Trade Show</div>
          <a><i class="fas fa-globe"></i> ktsh-ks.com</a>
          <p><i class="fas fa-phone-alt"></i> +383 49 937 856</p>
          <p><i class="far fa-envelope"></i> info@ktsh-ks.com</p>
        </div>
      </a>
    </div>
    <!-- NE PJESEN POSHTE TE DHENAT JANE DIMANIKE BAZUAR NE SHOPS NE ADMIN PANELET E HOMEFACE, 
    KU KEMI MUNDESINE PER SHTIMIN E SHOPS TE NDRYSHEM ME PRODUKTET E TIJ TE CILAT NDERLIDHEN PERMES SHOP_ID -->
    
    <!-- <div class="w-1/4 m-2 rounded overflow-hidden shadow-lg" v-for="shop in shops" :key="shop.id">
      <router-link :to="{ name: 'product-shop', params: { username: shop.username } }">
        <img class="w-full" src="./../../assets/images/no-image.jpg" alt="Shop Image" />
        <div class="px-6 py-4">
          <div class="font-bold text-xl mb-2">{{ shop.name }}</div>
          <p>{{ shop.domain }}</p>
          <p>{{ shop.phone }}</p>
          <p>{{ shop.address }}</p>
        </div>
      </router-link>
    </div> -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      shops: []
    };
  },
  created() {
    this.getShops();
  },
  methods: {
    getShops() {
      axios
        .get(`${process.env.VUE_APP_API}/shops`)
        .then(response => {
          //   console.log(response);
          this.shops = response.data.data;
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style>
</style>